import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaStar,
  FaChevronRight,
  FaFootballBall,
  FaHorseHead,
  FaDice,
  FaTrophy,
  FaHorse,
  FaBasketballBall,
  FaBaseballBall,
} from "react-icons/fa";

import { BiCricketBall, BiTennisBall } from "react-icons/bi";
import { useSelector } from "react-redux";
import Helper from "../../helper";
import Appconfig from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";
import "./SideMenu.css";

const SPORT_DEFINITIONS = [
  {
    id: "politics",
    label: "Politics",
    eventType: 0,
  },
  {
    id: "cricket",
    label: "Cricket",
    eventType: 4,
  },
  {
    id: "football",
    label: "Football",
    eventType: 1,
  },
  {
    id: "tennis",
    label: "Tennis",
    eventType: 2,
  },
  {
    id: "table-tennis",
    label: "Table Tennis",
    eventType: 8,
  },
  {
    id: "badminton",
    label: "Badminton",
    eventType: 10,
  },
  {
    id: "esoccer",
    label: "Esoccer",
    eventType: 15,
  },
  {
    id: "basketball",
    label: "Basketball",
    eventType: 7,
  },
  {
    id: "volleyball",
    label: "Volleyball",
    eventType: 11,
  },
  {
    id: "snooker",
    label: "Snooker",
    eventType: 14,
  },
  {
    id: "ice-hockey",
    label: "Ice Hockey",
    eventType: 12,
  },
];

const REFERENCE_MENU_ITEMS = [
  {
    id: "favourites",
    label: "Favourites",
    icon: "/Images/side-menu/99999.svg",
  },

  { id: "cricket", label: "Cricket", icon: "/Images/side-menu/4.svg" },
  { id: "football", label: "Football", icon: "/Images/side-menu/1.svg" },
  { id: "tennis", label: "Tennis", icon: "/Images/side-menu/2.svg" },

  {
    id: "fantasy11",
    label: "Fantasy 11",
    icon: "/Images/side-menu/979797.png",
    active: true,
  },

  {
    id: "cockfight",
    label: "Cock Fight",
    icon: "/Images/side-menu/969696.png",
  },
  { id: "politics", label: "Politics", icon: "/Images/side-menu/2378961.svg" },
  { id: "casino", label: "Casino", icon: "/Images/side-menu/99998.svg" },
  {
    id: "sportsbook",
    label: "Sports book",
    icon: "/Images/side-menu/99991.svg",
  },

  {
    id: "horseracing",
    label: "Horse Racing",
    icon: "/Images/side-menu/7.svg",
  },
  {
    id: "greyhound",
    label: "Greyhound Racing",
    icon: "/Images/side-menu/4339.svg",
  },

  { id: "other", label: "Other", icon: "" },
  { id: "binary", label: "Binary", icon: "/Images/side-menu/99990.svg" },
  { id: "kabaddi", label: "Kabaddi", icon: "/Images/side-menu/99994.svg" },

  { id: "basketball", label: "Basketball", icon: "/Images/side-menu/7522.svg" },
  { id: "baseball", label: "Baseball", icon: "/Images/side-menu/7511.svg" },
  {
    id: "tabletennis",
    label: "Table Tennis",
    icon: "/Images/side-menu/20.svg",
  },
  {
    id: "volleyball",
    label: "Volleyball",
    icon: "/Images/side-menu/998917.svg",
  },
  {
    id: "icehockey",
    label: "Ice Hockey",
    icon: "/Images/side-menu/7524.svg",
  },
  { id: "rugby", label: "Rugby", icon: "/Images/side-menu/5.svg" },
  {
    id: "mixedmartialarts",
    label: "Mixed Martial Arts",
    icon: "/Images/side-menu/26420387.svg",
  },
  { id: "darts", label: "Darts", icon: "/Images/side-menu/3503.svg" },
  { id: "futsal", label: "Futsal", icon: "/Images/side-menu/29.svg" },
  { id: "casino2", label: "Casino", icon: "/Images/side-menu/99999.svg" },
  { id: "genius", label: "Genius", icon: "" },
];

const SideMenu = ({
  handleToggleMenu,
  closeSideMenu,
  isMobile,
  whatsappNum,
  setEventType,
}) => {
  const navigate = useNavigate();
  const userInfo = Helper();
  const eventStore = useSelector((state) => state.events);
  const [search, setSearch] = useState("");
  const [selectedSport, setSelectedSport] = useState(null);
  const [menuDirection, setMenuDirection] = useState("forward");

  const [openSections, setOpenSections] = useState({
    racing: true,
    others: true,
    sports: true,
  });

  const [expandedSports, setExpandedSports] = useState({});

  const racingItems = [
    {
      id: "horse-racing",
      label: "Horse Racing",
      path: "/horse-racing",
    },
    {
      id: "greyhound-racing",
      label: "Greyhound Racing",
      path: "/greyhound-racing",
    },
  ];

  const otherItems = [
    {
      id: "our-casino",
      label: "Our Casino",
      disabled: true,
      blink: true,
    },
    {
      id: "our-vip-casino",
      label: "Our VIP Casino",
      disabled: true,
      blink: true,
    },
    {
      id: "our-premium-casino",
      label: "Our Premium Casino",
      disabled: true,
      blink: true,
    },
    {
      id: "our-virtual",
      label: "Our Virtual",
      disabled: true,
      blink: true,
    },
    {
      id: "live-casino",
      label: "Live Casino",
      casino: "evolution",
    },
    {
      id: "slot-game",
      label: "Slot Game",
      casino: "sa-gaming-casino",
    },
    {
      id: "fantasy-game",
      label: "Fantasy Game",
      casino: "fantasy",
    },
  ];

  const allEvents = useMemo(() => {
    const eventGroups = Array.isArray(eventStore?.events)
      ? eventStore.events
      : [];

    const flattenedEvents = eventGroups
      .flatMap((eventGroup) => eventGroup?.competitions || [])
      .flatMap((competition) => competition?.events || []);

    // Same event multiple competitions me aaye to duplicate remove hoga.
    return Array.from(
      new Map(
        flattenedEvents.map((event) => [
          String(event?.event_id ?? event?.eventId ?? event?._id),
          event,
        ]),
      ).values(),
    );
  }, [eventStore?.events]);

  const sportItems = useMemo(() => {
    return SPORT_DEFINITIONS.map((sport) => {
      const children = allEvents
        .filter((event) => {
          const eventType =
            event?.event_type ?? event?.eventType ?? event?.event_type_id;

          return String(eventType) === String(sport.eventType);
        })
        .map((event) => {
          const eventId = String(
            event?.event_id ?? event?.eventId ?? event?._id ?? "",
          );

          const eventName =
            event?.event_name ?? event?.eventName ?? event?.name ?? "Event";

          const inPlayValue =
            event?.is_inplay ?? event?.isInplay ?? event?.isInPlay;

          const isLive =
            inPlayValue === true ||
            inPlayValue === 1 ||
            inPlayValue === "1" ||
            String(inPlayValue).toLowerCase() === "true";

          return {
            id: eventId,
            label: eventName,
            eventId,
            isLive,
            path: `/matchupdates/${eventId}/${
              isLive ? "Inplay" : "Going Inplay"
            }`,
          };
        });

      return {
        ...sport,
        children,
      };
    });
  }, [allEvents]);

  const toggleSport = (sportId) => {
    setExpandedSports((previous) => {
      // Same sport dobara click hua to close hoga.
      if (previous[sportId]) {
        return {};
      }

      // Naya sport open hoga aur pehle wala close ho jayega.
      return {
        [sportId]: true,
      };
    });
  };

  const toggleSection = (sectionName) => {
    setOpenSections((current) => ({
      ...current,
      [sectionName]: !current[sectionName],
    }));
  };

  const closeMenu = () => {
    if (typeof closeSideMenu === "function") {
      closeSideMenu();
      return;
    }

    if (typeof handleToggleMenu === "function") {
      handleToggleMenu();
    }
  };

  const openPath = (item) => {
    if (item.eventType !== undefined && setEventType) {
      setEventType(item.eventType);
    }

    closeMenu();

    navigate(item.path, {
      state:
        item.eventType !== undefined
          ? { eventType: item.eventType }
          : undefined,
    });
  };

  const openCasino = (item) => {
    if (item.disabled) return;

    if (!userInfo?._id) {
      closeMenu();
      navigate("/login");
      return;
    }

    closeMenu();

    navigate("/all-games-lobby", {
      state: {
        activeCasino: item.casino,
      },
    });
  };

  const openSportLeague = (sport, event) => {
    if (sport.eventType !== undefined && typeof setEventType === "function") {
      setEventType(sport.eventType);
    }

    closeMenu();

    navigate(event.path, {
      state: {
        eventType: sport.eventType,
        eventId: event.eventId,
      },
    });
  };

  const filterItems = (items) => {
    const value = search.trim().toLowerCase();

    if (!value) return items;

    return items.filter((item) => item.label.toLowerCase().includes(value));
  };

  const filterSports = (items) => {
    const value = search.trim().toLowerCase();

    // Search empty hai to complete sports list return hogi
    if (!value) {
      return items;
    }

    return items
      .map((sport) => {
        // Sport name match ho raha hai ya nahi
        const sportMatches = sport.label.toLowerCase().includes(value);

        // Sport ke andar matching leagues
        const matchingChildren = (sport.children || []).filter((league) =>
          league.label.toLowerCase().includes(value),
        );

        /*
         * Na sport match hua aur na koi league,
         * to is sport ko result se remove kar denge.
         */
        if (!sportMatches && matchingChildren.length === 0) {
          return null;
        }

        /*
         * Agar sport ka naam match hua:
         * uski saari leagues show hongi.
         *
         * Agar sirf child league match hui:
         * sirf matching leagues show hongi.
         */
        return {
          ...sport,
          children: sportMatches ? sport.children : matchingChildren,
        };
      })
      .filter(Boolean);
  };

  const filteredRacing = useMemo(() => filterItems(racingItems), [search]);

  const filteredOthers = useMemo(() => filterItems(otherItems), [search]);

  const filteredSports = useMemo(() => filterSports(sportItems), [search]);

  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.casinoUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(userData),
    };

    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        }

        if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
          toast.error("Game Not Found.", { autoClose: 2000 });
        } else if (status == "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  // const handleAviator = () => {
  //   if (userInfo) {
  //     CreateAndLaunchWCOCasino(`SPB`, `aviator`);
  //   } else {
  //     setShowMenu(false);
  //     setShowLoginModel(true);
  //   }
  // };

  function OpenEzugiLobby(casinoType) {
    handleToggleMenu();
    navigate("/all-games-lobby", { state: { activeCasino: casinoType } });
  }

  const openWhatsApp = (whatsapp) => {
    const url = `https://wa.me/${whatsapp.replace(/\D/g, "")}`;
    window.open(url, "_blank");
  };

  // const MenuSection = ({ sectionKey, title, children }) => {
  //   const isOpen = openSections[sectionKey];

  //   return (
  //     <section className="reference-side-section">
  //       <button
  //         type="button"
  //         className="reference-side-section-heading"
  //         onClick={() => toggleSection(sectionKey)}
  //         aria-expanded={isOpen}
  //       >
  //         <span>{title}</span>

  //         {isOpen ? (
  //           <FaChevronUp aria-hidden="true" />
  //         ) : (
  //           <FaChevronDown aria-hidden="true" />
  //         )}
  //       </button>

  //       {isOpen && (
  //         <div className="reference-side-section-body">{children}</div>
  //       )}
  //     </section>
  //   );
  // };

  return (
    <aside
      className={[
        "reference-side-menu",
        isMobile ? "reference-side-menu-mobile" : "reference-side-menu-desktop",
      ].join(" ")}
      aria-label="Main navigation"
    >
      {/* Search and close */}
      {isMobile && (
        <div className="reference-side-search-row">
          <input
            type="search"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            className="reference-side-search"
            placeholder="Search here"
            aria-label="Search menu"
          />

          <button
            type="button"
            className="reference-side-close"
            onClick={closeMenu}
            aria-label="Close menu"
          >
            <i className="far fa-times-circle" aria-hidden="true" />
          </button>
        </div>
      )}

      <div className="reference-side-scroll">
        {selectedSport ? (
          <div className="reference-side-drill-panel">
            <button
              type="button"
              className="reference-side-previous-button"
              onClick={() => {
                setMenuDirection("back");
                setSelectedSport(null);
              }}
            >
              <span aria-hidden="true">‹</span>
              Previous
            </button>

            <div className="reference-side-selected-sport">
              {selectedSport.label}
            </div>

            {selectedSport.children?.length > 0 ? (
              selectedSport.children.map((league) => (
                <button
                  key={league.id}
                  type="button"
                  className="reference-side-drill-row"
                >
                  <span>{league.label}</span>

                  <span
                    className="reference-side-drill-chevron"
                    aria-hidden="true"
                  >
                    ›
                  </span>
                </button>
              ))
            ) : (
              <div className="reference-side-no-leagues">
                No events available
              </div>
            )}
          </div>
        ) : (
          <div
            className={[
              "reference-side-main-panel",
              menuDirection === "back" ? "reference-side-main-panel-back" : "",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            {REFERENCE_MENU_ITEMS.map((item) => {
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => {
                    const sport = sportItems.find(
                      (sportItem) => sportItem.id === item.id,
                    );

                    if (sport) {
                      setMenuDirection("forward");
                      setSelectedSport(sport);
                    }
                  }}
                  className={[
                    "reference-new-menu-row",
                    item.active ? "reference-new-menu-row-active" : "",
                    item.active ? "reference-side-fantasy-blink" : "",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                >
                  {item.id === "favourites" ? (
                    <i
                      className="far fa-star reference-new-menu-icon reference-favourites-icon"
                      aria-hidden="true"
                    />
                  ) : item.icon ? (
                    <img
                      src={item.icon}
                      alt=""
                      className="reference-new-menu-icon"
                      aria-hidden="true"
                    />
                  ) : (
                    <span
                      className="reference-new-menu-icon"
                      aria-hidden="true"
                    />
                  )}

                  <span className="reference-new-menu-label">{item.label}</span>

                  <span
                    className="reference-new-menu-chevron"
                    aria-hidden="true"
                  >
                    ›
                  </span>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </aside>
  );
};

export default SideMenu;
